import React, { createContext, useContext, useMemo } from 'react';
import { useMachine } from '@xstate/react';
import { trustyMachine } from '../lib/trustyMachine';

const TrustyActorContext = createContext();
const TrustyStateContext = createContext();

export const TrustyProvider = ({ children }) => {
  const [state, send, actor] = useMachine(trustyMachine);

  const actorValue = useMemo(() => ({ actor, send }), [actor, send]);

  return (
    <TrustyActorContext.Provider value={actorValue}>
      <TrustyStateContext.Provider value={state}>
        {children}
      </TrustyStateContext.Provider>
    </TrustyActorContext.Provider>
  );
};

export const useTrustyActor = () => {
  const context = useContext(TrustyActorContext);
  if (!context) throw new Error('useTrustyActor must be used within TrustyProvider');
  return context;
};

export const useTrustyState = () => {
  const context = useContext(TrustyStateContext);
  if (!context) throw new Error('useTrustyState must be used within TrustyProvider');
  return context;
};
